import { Box, BoxProps, rem } from '@bonusly/design-system';

export type HighlightBadgeProps = BoxProps;

export const HighlightBadge = (props: HighlightBadgeProps) => (
	<Box
		alignItems="center"
		as="span"
		bg="blackAlpha.50"
		border="none"
		borderRadius="full"
		bottom="auto"
		color="gray.600"
		display="inline-block"
		fontSize="xs"
		fontWeight="bold"
		lineHeight={rem(20)}
		px={1.5}
		{...props}
	/>
);
